import React from 'react';
export function UrgencyBar() {
  return <a href="#comprar" className="fixed top-0 left-0 right-0 z-50 bg-cta py-2 px-4 block hover:bg-cta/90 transition-colors cursor-pointer" data-id="element-364">
      <p className="text-center text-navy font-bold text-sm md:text-base" data-id="element-365">
        ⚡ PRECIO DE LANZAMIENTO: $6.39 — Acceso inmediato
      </p>
    </a>;
}